import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import SupportPopup from "../SupportPopup/SupportPopup";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { BsCheck2 } from "react-icons/bs";
import SELECTIMAGE from '../../assets/images/golf_image.png';
import { purchaseIronAPI } from "../../Api/staff";
import { Spinner } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { API_URL } from "../../Api/config";

function Steps() {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [apicall, setApicall] = React.useState(false);
    const [presentagebar, setPresentagebar] = useState(0);
    const [step_one_status, setStep_one_status] = useState('');
    const [step_two_status, setStep_two_status] = useState('');
    const [step_three_status, setStep_three_status] = useState('');

    const [firstimage, setFirstimage] = useState(false);
    const [secondimage, setSecondimage] = useState(false);
    const [thirdimage, setThirdimage] = useState(false);

    const [validated, setValidated] = useState(false);

    const [width, setWidth] = useState(window.innerWidth);

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [descripation, setDescripation] = useState('');
    const [serverSideError, setServerSideError] = useState(null);
    const [isSubmited, setIsSubmited] = useState(false);

    const handleSubmit = (event) => {
        setApicall(true);
        const form = event.currentTarget;

        setIsSubmited(true)

        if (form.checkValidity() === false || firstimage === false || secondimage === false || thirdimage === false) {

            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
            handleShow();
        } else {
            event.preventDefault();
            //check card is selected
            if (!cards.find(card => card.selected)) {
                handleShow();
                setApicall(false);
                return;
            }

            if (!ports.find(port => port.selected)) {
                handleShow();
                setApicall(false);
                return;
            }

            if (!finish.find(item => item.selected)) {
                handleShow();
                setApicall(false);
                return;
            }

            axios.post(API_URL + 'contact/createorder', {
                firstName: firstname,
                lastName: lastname,
                phoneNumber: phone,
                email: email,
                description: descripation,
                bounce: {
                    title: cards.find(card => card.selected)?.title,
                    id: cards.find(card => card.selected)?.id
                },
                finish: {
                    title: finish.find(item => item.selected)?.title,
                    id: finish.find(item => item.selected)?.id
                },
                ports: {
                    title: ports.find(port => port.selected)?.title,
                    id: ports.find(port => port.selected)?.id
                },
                subject: 'Purchase Iron'
            }
                , {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    console.log(response.data.status);
                    if (response.data.status === true) {
                        setFirstname('');
                        setLastname('');
                        setPhone('');
                        setEmail('');
                        setDescripation('');
                        setValidated(false);
                        setServerSideError(null);
                        setCards(cards.map(card => ({ ...card, selected: false })));
                        setFinish(finish.map(item => ({ ...item, selected: false })));
                        setPorts(ports.map(port => ({ ...port, selected: false })));
                        handleShow02();
                    }
                    else {

                    }
                    setApicall(false);
                })
                .catch(error => {
                    console.log("****", error);
                    setServerSideError(error.response.data);
                    // handle the error
                }).finally(() => {
                    setApicall(false);
                });
        }

        setValidated(true);
    };

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    })


    const [cards, setCards] = useState([
        {
            id: 1,
            name: 'Sole Design',
            title: 'Low',
            image1: require('../../assets/images/step-images/Bounce_Low_desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_Low_Mobile.jpg'),
            selected: false
        },
        {
            id: 2,
            name: 'Sole Design',
            title: 'Mid',
            image1: require('../../assets/images/step-images/Bounce_Mid_desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_Mid_Mobile.jpg'),
            selected: false
        },
        {
            id: 3,
            name: 'Sole Design',
            title: 'High',
            image1: require('../../assets/images/step-images/Bounce_High_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Bounce_High_Mobile.jpg'),
            selected: false
        },
    ]);

    const handleSelect = (cardId) => {
        const isSelecting = !cards.find((card) => card.id === cardId)?.selected;
        setPresentagebar(isSelecting ? 0 : 0);
        setStep_one_status(isSelecting ? 'active' : '');
        setFirstimage(isSelecting);

        setCards((prevCards) =>
            prevCards.map((card) => ({
                ...card,
                selected: card.id === cardId ? !card.selected : false
            }))
        );
    };


    const [finish, setFinish] = useState([
        {
            id: 1,
            name: 'Head Finish',
            title: 'Satin',
            image1: require('../../assets/images/step-images/Finish_Satin_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Satin_Mobile.png'),
            selected: false
        },
        {
            id: 2,
            name: 'Head Finish',
            title: 'Black',
            image1: require('../../assets/images/step-images/Finish_Black_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Black_Mobile.png'),
            selected: false
        },
        {
            id: 3,
            name: 'Head Finish',
            title: 'Copper',
            image1: require('../../assets/images/step-images/Finish_Copper_Desktop.jpg'),
            image2: require('../../assets/images/step-images/Finish_Copper_Mobile.png'),
            selected: false
        },
    ]);

    const handleSelectFinish = (finishId) => {
        const isSelecting = !finish.find((finish) => finish.id === finishId)?.selected;
        setPresentagebar(isSelecting ? 50 : 0);
        setSecondimage(isSelecting);
        setStep_two_status(isSelecting ? 'active' : '');

        setFinish((prevFinish) =>
            prevFinish.map((finish) => ({
                ...finish,
                selected: finish.id === finishId ? !finish.selected : false
            }))
        );
    };


    const [ports, setPorts] = useState([
        {
            id: 1,
            name: 'Port Finish',
            title: 'Silver',
            image1: require('../../assets/images/step-images/SilverPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/SilverPorts_Mobile.png'),
            selected: false
        },
        {
            id: 2,
            name: 'Port Finish',
            title: 'Black',
            image1: require('../../assets/images/step-images/BlackPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/BlackPorts_Mobile.png'),
            selected: false
        },
        {
            id: 3,
            name: 'Port Finish',
            title: 'Gold',
            image1: require('../../assets/images/step-images/GoldPorts_Desktop.jpg'),
            image2: require('../../assets/images/step-images/GoldPorts_Mobile.png'),
            selected: false
        },
    ]);

    const handleSelectPorts = (portsId) => {
        const isSelecting = !ports.find((port) => port.id === portsId)?.selected;
        setPresentagebar(isSelecting ? 100 : 50);
        setStep_three_status(isSelecting ? 'active' : '');
        setThirdimage(isSelecting);

        setPorts((prevPorts) =>
            prevPorts.map((port) => ({
                ...port,
                selected: port.id === portsId ? !port.selected : false
            }))
        );
    };


    const purchaseIronHead = () => {
        setApicall(true);
        const data = {
            catalog_id: "KTZ7BNZDUW7P4GHHMQPI5TLB"
        }
        purchaseIronAPI(data).then((res) => {
            if (res?.code === 200) {
                console.log("res", res.data.data);
                window.location.href = res.data.data
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
        });
    }

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);

    return (
        <>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmitClubOrder.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your club order is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our fitter will be in contact shortly to refine your order and make sure you are dialed
                    </p>
                </Modal.Body>
            </Modal>



            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className="center-form-modal model-info"
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <h3 className="text mb-5 text-center" style={{ color: '#ffffff' }}>
                            Please complete all your
                            iron selections and info
                            before submitting
                        </h3>
                    </div>
                    <div className='modal-footer-btn'>
                        <button
                            type="button"
                            className="btn btn-primary btn btn_default btn_disabled"
                            onClick={handleClose}
                        >
                            OK, got it
                        </button>
                    </div>
                </Modal.Body>
            </Modal>


            <section id="our_step" className="our_process bg_dark page-section bg_img">
                <div className="container-xl custom_md_100">
                    <div className="d-flex align-items-center justify-content-start sec_tile_bar">
                        <div>
                            <span>Step 1</span>
                            <h2 className="sec_title">Your Bounce</h2>
                        </div>
                    </div>
                    <div className="row">
                        {cards.map((card) => (
                            <div className="col-lg-4" key={card.id}>
                                <div className={card.selected ? 'gs_b step_card selected' : 'step_card gs_b'}>
                                    <div className="step-img">
                                        {width > 600 ? (
                                            <img src={card.image1} alt="" className="desktop_img" />
                                        ) : (
                                            <img src={card.image2} alt="" className="mobile_img" />
                                        )}
                                    </div>

                                    <div className="mb-0">
                                        <div className="step_card_content px-0">
                                            <div className="gab_title">
                                                <div className="gab_text">
                                                    <small>{card.name}</small>
                                                    <h5>{card.title}</h5>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => handleSelect(card.id)}
                                                className="btn btn_default bg-white text-dark"
                                            >
                                                {card.selected ? 'Selected' : 'Select'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="container-xl custom_md_100">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div>
                            <span>Step 2</span>
                            <h2 className="sec_title">Your Finish</h2>
                        </div>
                    </div>
                    <div className="row">
                        {finish.map((finish) => (
                            <div className="col-lg-4" key={finish.id}>
                                <div className={finish.selected ? 'gs_b step_card selected' : 'step_card gs_b'}>
                                    <div className="step-img">
                                        {width > 600 ? (
                                            <img src={finish.image1} alt="" className="desktop_img" />
                                        ) : (
                                            <img src={finish.image2} alt="" className="mobile_img" />

                                        )}
                                    </div>
                                    <div className="mb-0">
                                        <div className="step_card_content px-0">
                                            <div className="gab_title">
                                                <div className="gab_text">
                                                    <small>{finish.name}</small>
                                                    <h5>{finish.title}</h5>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => handleSelectFinish(finish.id)}
                                                className="btn btn_default bg-white text-dark"
                                            >
                                                {finish.selected ? 'Selected' : 'Select'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                <div className="container-xl custom_md_100">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div>
                            <span>Step 3</span>
                            <h2 className="sec_title">Your Ports</h2>
                        </div>
                    </div>
                    <div className="row">
                        {ports.map((ports) => (
                            <div className="col-lg-4" key={ports.id}>
                                <div className={ports.selected ? 'gs_b step_card selected' : 'step_card gs_b'}>
                                    <div className="step-img">
                                        {width > 600 ? (
                                            <img src={ports.image1} alt="" className="desktop_img" />
                                        ) : (
                                            <img src={ports.image2} alt="" className="mobile_img" />
                                        )}
                                    </div>
                                    <div className="mb-0">
                                        <div className="step_card_content px-0">
                                            <div className="gab_title">
                                                <div className="gab_text">
                                                    <small>{ports.name}</small>
                                                    <h5>{ports.title}</h5>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => handleSelectPorts(ports.id)}
                                                className="btn btn_default bg-white text-dark"
                                            >
                                                {ports.selected ? 'Selected' : 'Select'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                <div className="container-xl custom_md_100 hide_mobile">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div>
                            <span>Step 4</span>
                            <h2 className="sec_title">Review Irons</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-lg-4 col-md-4 col-sm-4'>
                            <div className="step-img mb-4">
                                <img
                                    src={firstimage && cards.find(card => card.selected)?.image1 ? cards.find(card => card.selected)?.image1 : require('../../assets/images/thumb_img_step.png')}
                                    alt=""
                                    className={isSubmited && firstimage === false ? 'alert-img' : ''}
                                />

                                {
                                    isSubmited && firstimage === false && <p className="text-danger">Please select Sole Design</p>
                                }
                            </div>

                            <div className='text_item'>
                                <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                    <div className={`iron_step_icon ${step_one_status}`}>
                                        <BsCheck2 />
                                    </div>
                                    <div>
                                        <span>Sole Design</span>
                                        <h4>{cards.find(card => card.selected)?.title}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-4'>
                            <div className="step-img mb-4">
                                <img
                                    src={secondimage && finish.find(item => item.selected)?.image1 ? finish.find(item => item.selected)?.image1 : require('../../assets/images/thumb_img_step.png')}
                                    alt=""
                                    className={isSubmited && secondimage === false ? 'alert-img' : ''}
                                />
                                {
                                    isSubmited && secondimage === false && <p className="text-danger">Please select club finish</p>
                                }
                            </div>
                            <div className='text_item'>
                                <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                    <div className={`iron_step_icon ${step_two_status}`}>
                                        <BsCheck2 />
                                    </div>
                                    <div>
                                        <span>Club Finish</span>
                                        <h4>{finish.find(item => item.selected)?.title}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-4'>
                            <div className="step-img mb-4">
                                <img
                                    src={thirdimage && ports.find(port => port.selected)?.image1 ? ports.find(port => port.selected)?.image1 : require('../../assets/images/thumb_img_step.png')}
                                    alt=""
                                    className={isSubmited && thirdimage === false ? 'alert-img' : ''}
                                />
                                {
                                    isSubmited && thirdimage === false && <p className="text-danger">Please select port finish</p>
                                }
                            </div>
                            <div className='text_item'>
                                <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                    <div className={`iron_step_icon ${step_three_status}`}>
                                        <BsCheck2 />
                                    </div>
                                    <div>
                                        <span>Port Finish</span>
                                        <h4>{ports.find(port => port.selected)?.title}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-12'>
                            <div className='set_step'>
                                {/* <ProgressBar
                                    percent={presentagebar}
                                    filledBackground="#99ea24"
                                >
                                    <Step transition="scale" >
                                        {({ accomplished }) => (
                                            <div className={`iron_step_icon ${step_one_status}`}>
                                                <BsCheck2 />
                                            </div>
                                        )}
                                    </Step>
                                    <Step transition="scale">
                                        {({ accomplished }) => (
                                            <div className={`iron_step_icon ${step_two_status}`}>
                                                <BsCheck2 />
                                            </div>
                                        )}
                                    </Step>
                                    <Step transition="scale">
                                        {({ accomplished }) => (
                                            <div className={`iron_step_icon ${step_three_status}`}>
                                                <BsCheck2 />
                                            </div>
                                        )}
                                    </Step>
                                </ProgressBar> */}

                                {/* <div className='text_item'>
                                    <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                        <div className={`iron_step_icon ${step_one_status}`}>
                                            <BsCheck2 />
                                        </div>
                                        <div>
                                            <span>Sole Design</span>
                                            <h4>{cards.find(card => card.selected)?.title}</h4>
                                        </div>
                                    </div>
                                    <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                        <div className={`iron_step_icon ${step_two_status}`}>
                                            <BsCheck2 />
                                        </div>
                                        <div>
                                            <span>Club Finish</span>
                                            <h4>{finish.find(item => item.selected)?.title}</h4>
                                        </div>
                                    </div>
                                    <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                        <div className={`iron_step_icon ${step_three_status}`}>
                                            <BsCheck2 />
                                        </div>
                                        <div>
                                            <span>Port Finish</span>
                                            <h4>{ports.find(port => port.selected)?.title}</h4>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>


                <div className="container-xl custom_md_100 show_mobile">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div>
                            <span>Step 4</span>
                            <h2 className="sec_title">Review Irons</h2>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className='col-lg-12'>
                            <div className='img_list'>
                                <div className="step-img-mobile">
                                    <img
                                        src={firstimage && cards.find(card => card.selected)?.image2 ? cards.find(card => card.selected)?.image2 : require('../../assets/images/thumb_img.jpg')}
                                        alt=""
                                        className={isSubmited && firstimage === false ? 'alert-img' : ''}
                                    />
                                    {
                                        isSubmited && firstimage === false && <p className="text-danger">Please select sole design</p>
                                    }
                                    <div className='text_item'>
                                        <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                            <div className={`iron_step_icon ${step_one_status}`}>
                                                <BsCheck2 />
                                            </div>
                                            <div>
                                                <span>Sole Design</span>
                                                <h4>{cards.find(card => card.selected)?.title}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="step-img-mobile">
                                    <img
                                        src={secondimage && finish.find(item => item.selected)?.image2 ? finish.find(item => item.selected)?.image2 : require('../../assets/images/thumb_img.jpg')}
                                        alt=""
                                        className={isSubmited && secondimage === false ? 'alert-img' : ''}
                                    />
                                    {
                                        isSubmited && secondimage === false && <p className="text-danger">Please select club finish</p>
                                    }
                                    <div className='text_item'>
                                        <div className='text_step_1 border_step d-flex align-items-center justify-content-between flex-direction-column'>
                                            <div className={`iron_step_icon ${step_two_status}`}>
                                                <BsCheck2 />
                                            </div>
                                            <div>
                                                <span>Club Finish</span>
                                                <h4>{finish.find(item => item.selected)?.title}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="step-img-mobile">
                                    <img
                                        src={thirdimage && ports.find(port => port.selected)?.image2 ? ports.find(port => port.selected)?.image2 : require('../../assets/images/thumb_img.jpg')}
                                        alt=""
                                        className={isSubmited && thirdimage === false ? 'alert-img' : ''}
                                    />
                                    {
                                        isSubmited && thirdimage === false && <p className="text-danger">Please select port finish</p>
                                    }
                                    <div className='text_item'>
                                        <div className='text_step_1 d-flex align-items-center justify-content-between flex-direction-column'>
                                            <div className={`iron_step_icon ${step_three_status}`}>
                                                <BsCheck2 />
                                            </div>
                                            <div>
                                                <span>Port Finish</span>
                                                <h4>{ports.find(port => port.selected)?.title}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container-xl'>
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div>
                            <span>Step 5</span>
                            <h2 className="sec_title">Start Order</h2>
                        </div>
                    </div>
                    <div className=''>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper hide_desktop mb-5">
                                    <div id="v-video" className="v-video">
                                        <iframe
                                            // ref="playerRefs"
                                            src="https://player.vimeo.com/video/898470504?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                                            frameborder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowfullscreen=""
                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            title="Video-1"
                                            data-ready="true"
                                        ></iframe>
                                    </div>
                                </div>
                                <div className='pr_card card-radius card-dark bg_dark_black card-dark-pr'>
                                    <div className=''>
                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <div className="row gx-2">
                                                <div className="col-md-6 form-group" controlid="validationCustom01">
                                                    <input type="text" name="f-name" className="form-control dashboard-input-box-3" value={firstname} onChange={(e) => setFirstname(e.target.value)} placeholder="First name" required />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter a first name.
                                                    </Form.Control.Feedback>
                                                </div>
                                                <div className="col-md-6 form-group" controlid="validationCustom02">
                                                    <input type="text" name="l-name" className="form-control dashboard-input-box-3" value={lastname} placeholder="Last name" onChange={(e) => setLastname(e.target.value)} required />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter a last name.
                                                    </Form.Control.Feedback>
                                                </div>
                                                <div className="col-md-12 form-group" controlid="validationCustom03">
                                                    <input type="tel" name="name" pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." value={phone} onChange={(e) => setPhone(e.target.value)} className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter a 8-digit phone number.
                                                    </Form.Control.Feedback>
                                                    {serverSideError && (serverSideError.data).map((error, index) => (
                                                        error.field === 'phone_number' ? (
                                                            <div className="text-danger" key={index}>{error.detail}</div>
                                                        ) : null
                                                    ))}
                                                </div>
                                                <div className="col-md-12 form-group" controlid="validationCustom04">
                                                    <input type="email" className="form-control dashboard-input-box-3" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please choose a email.
                                                    </Form.Control.Feedback>
                                                    {serverSideError && (serverSideError.data).map((error, index) => (
                                                        error.field === 'email' ? (
                                                            <div className="text-danger" key={index}>{error.detail}</div>
                                                        ) : null
                                                    ))}
                                                </div>
                                                <div className='col-md-12 form-group'>
                                                    <textarea className="form-control dashboard-input-box-3 step-textarea-box" name="message" value={descripation} onChange={(e) => setDescripation(e.target.value)} placeholder="Anything you want us to know?" rows="13"></textarea>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className='full-width-btn'>
                                                        <button className="btn btn_default bg-white text-dark btn_disabled" type="submit">
                                                            {
                                                                apicall ? <Spinner animation="border" className="border-black" /> : <span>Start Your Order</span>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper hide_mobile hide_tablet">
                                    <div id="v-video" className="v-video">
                                        <iframe
                                            // ref="playerRefs"
                                            src="https://player.vimeo.com/video/898470504?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                                            frameborder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowfullscreen=""
                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            title="Video-1"
                                            data-ready="true"
                                        ></iframe>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 accordion-item acc_items">
                                        <div className="points_sec start_over_sec">
                                            <h4 className="custom-collapse" id="fitter_p1">
                                                <span className="collapsed">
                                                    Why not pay right now?
                                                </span>
                                            </h4>
                                            <p id="fitter_pc1" className="accordion-collapse" aria-labelledby="fitter_p1">
                                                We are not an ecommerce business that sells clubs off of a website. We stand by what we sell and want to communicate first.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 accordion-item acc_items">
                                        <div className="points_sec start_over_sec">
                                            <h4 className="custom-collapse" id="fitter_p2">
                                                <span className="collapsed">
                                                    What happens next
                                                </span>
                                            </h4>
                                            <p id="fitter_pc2" className="accordion-collapse" aria-labelledby="fitter_p2">
                                                Our staff will reach out and speak to you directly within 24 hours. Not a single set of irons will leave our door if they aren’t right.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div className="container-xl">
                    <div className="row">
                        <div className='col-lg-6'>
                            <div className='hide_mobile'>
                                <div className="gs_b card_btn_content step_card">
                                    <div className="gab_title">
                                        <div className="gab_text">
                                            <small>Need a custom build?</small>
                                            <h5>Send us a message</h5>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn_default bg-white text-dark"
                                    >Inquire Here
                                    </button>
                                </div>
                            </div>
                            <div className='show_mobile'>
                                <div className="gs_b card_btn_content step_card">
                                    <div className="gab_title">
                                        <div className="gab_text">
                                            <small>Need a custom build?</small>
                                            <h5>Message us here</h5>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn_default bg-white text-dark"
                                    >Inquire
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 order-first order-md-1'>
                            <div className='hide_mobile'>
                                <div className="gs_b card_btn_content step_card">
                                    <div className="gab_title">
                                        <div className="gab_text">
                                            <small>Purchase Iron Heads</small>
                                            <h5>Buy now for:</h5>
                                        </div>
                                    </div>
                                    {
                                        presentagebar === 100 ? (
                                            apicall ?
                                                <button className="btn btn_default bg-white text-dark btn_disabled">
                                                    <Spinner animation="border" className="border-black" />
                                                </button> :

                                                <button
                                                    className="btn btn_default bg-white text-dark btn_disabled"
                                                    onClick={purchaseIronHead}
                                                >Purchase Here
                                                </button>
                                        ) : (

                                            <button
                                                disabled
                                                className="btn btn_default bg-white text-dark btn_disabled"
                                            >Purchase Here
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                            <div className='show_mobile'>
                                <div className="gs_b card_btn_content step_card">
                                    <div className="gab_title">
                                        <div className="gab_text">
                                            <small>Purchase Iron Heads</small>
                                            <h5>Buy now:</h5>
                                        </div>
                                    </div>
                                    <button
                                        disabled
                                        className="btn btn_default bg-white text-dark btn_disabled"
                                    >Purchase
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </section>
        </>
    )
}

export default Steps;